export default __webpack_public_path__ + "static/media/080_finish_bad.av1.550da4af.mp4";